const config = {
  baseUrl: '/api',
  analyticsId: 'G-F78Q1CK9CY',
};

export default config;
